import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type CouponUser = {
  coupon_user_id?: number; // 쿠폰함 idx
  user_id?: number; // 유저 idx
  product_policy?: number; // 상품정책 idx
  coupon_id?: number; // 쿠폰 idx
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

export type CouponUserBulk = {
  coupon_id?: number; // 유저 idx
  user_ids?: { user_id: number }[]; // 유저 idx
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] CouponUser
   * --
   */
  getCouponUsers: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_COUPON_USER, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] CouponUser
   * --
   */
  getCouponUser: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_COUPON_USER, {
        coupon_user_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] CouponUser
   * --
   */
  createCouponUser: async (body: CouponUser) => {
    try {
      const res = await $http.post(APIConstant.CREATE_COUPON_USER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] CouponUser
   * --
   */
  updateCouponUser: async (body: CouponUser) => {
    try {
      const { coupon_user_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_COUPON_USER, {
        coupon_user_id: coupon_user_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] CouponUser
   * --
   */
  deleteCouponUser: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_COUPON_USER, {
        coupon_user_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] CouponUser
   * --
   */
  registerCouponUser: async (body: CouponUser) => {
    try {
      const res = await $http.post(APIConstant.REGISTER_COUPON_USER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] CouponUser
   * --
   */
  bulkCreateCouponUser: async (body: CouponUserBulk) => {
    try {
      const res = await $http.post(APIConstant.BULK_CREATE_COUPON_USER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] CouponUser
   * --
   */
  bulkUpdateCouponUser: async (body: CouponUserBulk[]) => {
    try {
      const res = await $http.put(APIConstant.BULK_UPDATE_COUPON_USER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
